import { render, staticRenderFns } from "./Page_list.vue?vue&type=template&id=51fd1e7b&scoped=true"
import script from "./Page_list.vue?vue&type=script&lang=js"
export * from "./Page_list.vue?vue&type=script&lang=js"
import style0 from "./Page_list.vue?vue&type=style&index=0&id=51fd1e7b&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51fd1e7b",
  null
  
)

export default component.exports